import { http } from "@/lib/request";

export interface WellnessNextCare {
  new_user?: boolean;
  title?: string;
  main_text?: string;
  sub_text?: string;
  button_text?: string;
  target_url?: string;
  days_until_next?: number;
  last_service_days?: number;
}

export interface WellnessContentCard {
  id: number;
  content_type?: string;
  title?: string;
  subtitle?: string;
  summary?: string;
  content?: string;
  image_url?: string;
  icon?: string;
  tags?: string;
  season?: string;
  display_date?: string;
  day_of_year?: number;
  source_name?: string;
  source_url?: string;
}

export interface WellnessGoodsCard {
  goods_id: number;
  name?: string;
  image?: string;
  price?: number;
  duration?: number;
  is_append_goods?: number;
  recommend_reason?: string;
}

export interface WellnessPersonaCard {
  id: number;
  code?: string;
  name?: string;
  summary?: string;
  description?: string;
  icon?: string;
  tags?: string;
  goods?: WellnessGoodsCard[];
}

export interface WellnessGuideResult {
  next_care?: WellnessNextCare;
  today?: WellnessContentCard[];
  tips?: WellnessContentCard[];
  seasonal?: WellnessContentCard[];
  personas?: WellnessPersonaCard[];
}

export const wellnessApi = {
  getGuide() {
    return http.get<WellnessGuideResult>("/wellness/guide");
  },
};
